/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface WaypointFrameType {
}

export enum WaypointFrameType_Enum {
  UNKNOWN = 0,
  NAV = 1,
  WORLD = 2,
  GPS = 3,
  GLOBAL_MAP = 4,
  NAV_TAKEOFF = 5,
  NAV_CAM_POSE_GRAPH = 6,
  WORLD_PILOT_RELATIVE = 7,
  WORLD_TAKEOFF = 8,
  NAV_HEIGHT_ABOVE_GROUND = 9,
  SITE = 10,
  GPS_ABOVE_GROUND_LEVEL = 11,
  WORLD_DOCK_RELATIVE = 12,
  NAV_DOCK_RELATIVE = 13,
  UNRECOGNIZED = -1,
}

export function waypointFrameType_EnumFromJSON(object: any): WaypointFrameType_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return WaypointFrameType_Enum.UNKNOWN;
    case 1:
    case "NAV":
      return WaypointFrameType_Enum.NAV;
    case 2:
    case "WORLD":
      return WaypointFrameType_Enum.WORLD;
    case 3:
    case "GPS":
      return WaypointFrameType_Enum.GPS;
    case 4:
    case "GLOBAL_MAP":
      return WaypointFrameType_Enum.GLOBAL_MAP;
    case 5:
    case "NAV_TAKEOFF":
      return WaypointFrameType_Enum.NAV_TAKEOFF;
    case 6:
    case "NAV_CAM_POSE_GRAPH":
      return WaypointFrameType_Enum.NAV_CAM_POSE_GRAPH;
    case 7:
    case "WORLD_PILOT_RELATIVE":
      return WaypointFrameType_Enum.WORLD_PILOT_RELATIVE;
    case 8:
    case "WORLD_TAKEOFF":
      return WaypointFrameType_Enum.WORLD_TAKEOFF;
    case 9:
    case "NAV_HEIGHT_ABOVE_GROUND":
      return WaypointFrameType_Enum.NAV_HEIGHT_ABOVE_GROUND;
    case 10:
    case "SITE":
      return WaypointFrameType_Enum.SITE;
    case 11:
    case "GPS_ABOVE_GROUND_LEVEL":
      return WaypointFrameType_Enum.GPS_ABOVE_GROUND_LEVEL;
    case 12:
    case "WORLD_DOCK_RELATIVE":
      return WaypointFrameType_Enum.WORLD_DOCK_RELATIVE;
    case 13:
    case "NAV_DOCK_RELATIVE":
      return WaypointFrameType_Enum.NAV_DOCK_RELATIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WaypointFrameType_Enum.UNRECOGNIZED;
  }
}

export function waypointFrameType_EnumToJSON(object: WaypointFrameType_Enum): string {
  switch (object) {
    case WaypointFrameType_Enum.UNKNOWN:
      return "UNKNOWN";
    case WaypointFrameType_Enum.NAV:
      return "NAV";
    case WaypointFrameType_Enum.WORLD:
      return "WORLD";
    case WaypointFrameType_Enum.GPS:
      return "GPS";
    case WaypointFrameType_Enum.GLOBAL_MAP:
      return "GLOBAL_MAP";
    case WaypointFrameType_Enum.NAV_TAKEOFF:
      return "NAV_TAKEOFF";
    case WaypointFrameType_Enum.NAV_CAM_POSE_GRAPH:
      return "NAV_CAM_POSE_GRAPH";
    case WaypointFrameType_Enum.WORLD_PILOT_RELATIVE:
      return "WORLD_PILOT_RELATIVE";
    case WaypointFrameType_Enum.WORLD_TAKEOFF:
      return "WORLD_TAKEOFF";
    case WaypointFrameType_Enum.NAV_HEIGHT_ABOVE_GROUND:
      return "NAV_HEIGHT_ABOVE_GROUND";
    case WaypointFrameType_Enum.SITE:
      return "SITE";
    case WaypointFrameType_Enum.GPS_ABOVE_GROUND_LEVEL:
      return "GPS_ABOVE_GROUND_LEVEL";
    case WaypointFrameType_Enum.WORLD_DOCK_RELATIVE:
      return "WORLD_DOCK_RELATIVE";
    case WaypointFrameType_Enum.NAV_DOCK_RELATIVE:
      return "NAV_DOCK_RELATIVE";
    case WaypointFrameType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseWaypointFrameType(): WaypointFrameType {
  return {};
}

export const WaypointFrameType = {
  encode(_: WaypointFrameType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaypointFrameType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypointFrameType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaypointFrameType {
    return {};
  },

  toJSON(_: WaypointFrameType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaypointFrameType>, I>>(base?: I): WaypointFrameType {
    return WaypointFrameType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaypointFrameType>, I>>(_: I): WaypointFrameType {
    const message = createBaseWaypointFrameType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
